const spots = ["cadiz", "malaga", "tarifa", "algeciras", "almeria"];

export default spots;
